import { TwoColumnLayout } from 'layouts';
import type { Event } from 'models';
import { EventDetailCountdown } from '../../components';
import { PublicEventHeader } from '../../public-event-header';
import { SharedEventEnter } from './shared-event-enter';

type P = {
  event: Event;
  invitationToken: string;
};

const SharedEventContent = ({ event, invitationToken }: P) => (
  <>
    <PublicEventHeader event={event} />
    <TwoColumnLayout
      left={<SharedEventEnter event={event} invitationToken={invitationToken} />}
      right={<EventDetailCountdown startTime={event.startTime} />}
    />
  </>
);

export default SharedEventContent;
